module.exports = __webpack_public_path__ + "assets/img/evalute-succes-back.335de492.png";